import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Pagination.module.scss';

const Pagination = ({
  page,
  pageCount,
  onPageChange,
  total,
  itemLabel,
  showInfo,
  className,
}) => {
  const safePageCount = Math.max(0, Number(pageCount) || 0);
  const safePage = Math.min(Math.max(1, Number(page) || 1), Math.max(1, safePageCount));

  if (safePageCount <= 0) return null;

  const wrapperClasses = [styles.wrapper, className || ''].filter(Boolean).join(' ');

  return (
    <nav className={wrapperClasses} aria-label="Pagination">
      {showInfo && (
        <div className={styles.info}>
          {total != null ? (
            <>
              Page <strong>{safePage}</strong> of <strong>{safePageCount}</strong> ·{' '}
              <strong>{total}</strong> {itemLabel}
            </>
          ) : (
            <>
              Page <strong>{safePage}</strong> of <strong>{safePageCount}</strong>
            </>
          )}
        </div>
      )}
      <ReactPaginate
        forcePage={safePage - 1}
        pageCount={safePageCount}
        onPageChange={({ selected }) => onPageChange?.(selected + 1)}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="…"
        containerClassName={styles.list}
        previousClassName={styles.edge}
        nextClassName={styles.edge}
        breakClassName="break"
        activeClassName="selected"
        disabledClassName="disabled"
        renderOnZeroPageCount={null}
      />
    </nav>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  total: PropTypes.number,
  itemLabel: PropTypes.string,
  showInfo: PropTypes.bool,
  className: PropTypes.string,
};

Pagination.defaultProps = {
  total: null,
  itemLabel: 'items',
  showInfo: true,
  className: '',
};

export default Pagination;
